<template lang="pug">
  router-link.logo(:class="logoClass" to='/')
      include ../../assets/images/svg/6.svg
</template>

<script>
export default {
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoClass () {
      return this.white ? 'logo_color_white' : null
    }
  }
}
</script>

<style lang="scss">
  .logo {
    width: 146px;
    height: 18px;
    fill: #fe710e;
    img {
      width: 100%;
    }

    &_color_white {
      fill: #fff;
    }

    &_color_orange {
      fill: #fe710e;
    }
    img {
      width: 100%;
    }
  }
</style>
